// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v2.users.properties.discriminatorycontent.RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler

import { getClient } from '../../client';
import { httpFrontEndRequest } from '@zg-rentals/ts-client-http-client';

import type { CheckDiscriminatoryContentResponseV2WebDto, CheckDiscriminatoryContentV2RequestDto } from '../..';

export const RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_Path =
  '/api/web/v2/users/properties/checkDiscriminatoryContent';

/**
 * Check whether the supplied text contains discriminatory content for a manual listing
 */
export const RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent = (
  postData: CheckDiscriminatoryContentV2RequestDto,
  client = getClient(),
) => {
  return httpFrontEndRequest<never, CheckDiscriminatoryContentV2RequestDto, CheckDiscriminatoryContentResponseV2WebDto>(
    {
      endpoint: RentalManagerUserPropertyDiscriminatoryContentV2WebApiHandler_checkDiscriminatoryContent_Path,
      method: 'POST',
      contextPath: '/rental-manager-api',
      postData: postData,
    },
    client,
  );
};
